import React, { Component } from 'react';

class App extends Component {
  render() {
    return (
      <div className="App">
        Error Page
      </div>
    );
  }
}

export default App;
